import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Draggable from 'react-draggable';

//material core
import Box from '@material-ui/core/Box';

//material icons
import Grid from '@material-ui/core/Grid';
import {Button, Card, Divider, Typography} from '@material-ui/core';

import useHook from './legend.hooks';

const useStyles = makeStyles((theme) => ({
  //legend content
  box: {
    width: 225,
    padding: '0.5vh',
    paddingBottom: 25,
    height: 180,
    position: 'absolute',
    top: theme.spacing(21),
    right: theme.spacing(1),
    margin: theme.spacing(0),
    backgroundColor: 'white',
  },

  //legend item
  item: {
    borderRadius: 100,
    padding: 1,
    marginRight: 10,
    paddingLeft: 15,
  },
}));

const LegendPendataan = (props) => {
  const classes = useStyles();

  const [{legendPendataan}] = useHook(props);

  const ListLegend = (props1) => {
    const {data} = props1;
    return (
      <Grid item xs={12} style={{fontSize: 12, marginLeft: 10}}>
        <i className={classes.item} style={{backgroundColor: data.warna}} />
        {data.label}
      </Grid>
    );
  };

  const DraggableCard = () => {
    return (
      <Draggable>
        <Box className={classes.box} boxShadow={3}>
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                alignSelf: 'center',
                textAlign: '-webkit-center',
                cursor: 'move',
                width: 200,
              }}>
              Pelayanan
            </Grid>
          </Grid>

          <Divider
            style={{
              marginTop: 5,
              marginBottom: 10,
              marginLeft: 35,
              marginRight: 35,
            }}
          />

          <Grid container spacing={1}>
            {legendPendataan.map((value, key) => {
              return <ListLegend data={value} key={key} />;
            })}
          </Grid>
        </Box>
      </Draggable>
    );
  };

  return (
    <div>
      <DraggableCard />
    </div>
  );
};

export default LegendPendataan;
